import {
  FETCH_COMPANIES,
  FETCH_DATA_COMPANIES,
} from '../../constants/ActionTypes'
const INITIAL_STATE = {
  companies: [],
  dataCompanies: [],
  totalPointsNotRedeemed: 0,
  totalPointsRedeemed: 0,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPANIES:
      if (action.payload == undefined) {
        return state
      } else {
        const companies = action.payload.map(value => value)
        return {...state, companies}
      }
    case FETCH_DATA_COMPANIES:
      if (action.payload.success == 0) {
        return state
      } else {
        const dataCompanies = action.payload.result.map(value => value)

        return {
          ...state,
          dataCompanies,
          totalPointsNotRedeemed: action.payload.totalPointsNotRedeemed,
          totalPointsRedeemed: action.payload.totalPointsRedeemed,
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/appRedux/reducers/Companies.js